module.exports = __webpack_public_path__ + "img/3CX_intermediate.8163a0d1.png";